module.exports = __webpack_public_path__ + "img/service04.b4c29fe1.png";